import { format, parse, parseISO } from 'date-fns';

export const DATE_FORMAT = {
  DATE: 'yyyy-MM-dd',
  DATE_TIME: 'yyyy-MM-dd HH:mm',
  DATE_TIME_SECOND: 'yyyy-MM-dd HH:mm:ss',
} as const;

export type DateFormat = typeof DATE_FORMAT[keyof typeof DATE_FORMAT];

/**
 * UTC 日時文字列をフォーマットされた JST 日時文字列に変換する
 * @param date 日付文字列（例: 2022-01-24T00:00:00Z）
 * @param dateFormat フォーマットされた JST 日付文字列（例: 2022-01-24 09:00）
 * @returns
 */
export const convertUTCStringIntoJSTString = (
  date: string,
  dateFormat: DateFormat = DATE_FORMAT.DATE_TIME,
): string => {
  const zoneDate = parseISO(date);
  const formatedDate = format(zoneDate, dateFormat);

  return formatedDate;
};

/**
 * フォームで入力された日時を ISO 8601 形式の UTC 日付に変換する
 * @param formDatetime フォームで入力された日時（例: 2022-02-22 15:00)
 * @returns ISO 8601 に準拠したフォーマットの UTC 日付（例: 2022-02-22T15:00:00.000Z)
 */
export const convertFormDatetimeIntoISOString = (
  formDatetime: string,
): string => new Date(formDatetime).toISOString();

/**
 * Date オブジェクトを yyy-MM-dd 形式の日付文字列に変換する
 * @param date
 * @returns
 */
export const convertDateIntoDateString = (date: Date): string =>
  format(date, DATE_FORMAT.DATE);

/**
 * yyy-MM-dd 形式の日付文字列を Date オブジェクトに変換する
 * @param dateTime 日付文字列（例: 2022-02-22)
 * @returns
 */
export const parseDateString = (dateTime: string): Date =>
  parse(dateTime, DATE_FORMAT.DATE, new Date());

/**
 * Date オブジェクトを yyy-MM-dd HH:mm 形式の日付文字列に変換する
 * @param date
 * @returns
 */
export const convertDateIntoDateTimeString = (date: Date): string =>
  format(date, DATE_FORMAT.DATE_TIME);

/**
 * yyy-MM-dd HH:mm 形式の日付文字列を Date オブジェクトに変換する
 * @param dateTime 日付文字列（例: 2022-02-22 15:00)
 * @returns
 */
export const parseDateTimeString = (dateTime: string): Date =>
  parse(dateTime, DATE_FORMAT.DATE_TIME, new Date());
